module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Client Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.showUploadModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload mr-1"
  }), _vm._v("Upload Sales Person-Client Map")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": _vm.goToClientDashboard
    }
  }, [_vm._v("Client TEUS Dashboard")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Client")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_CLIENT_Report', 'Export as Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName1 != 'New Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsNew('All_CLIENT_ReportNew', 'New Export as Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName1) + "\n              "), (_vm.ExcelBtnName1 != 'New Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }), _vm._v(" "), _c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.FilterData.CommonFilter),
      callback: function($$v) {
        _vm.$set(_vm.FilterData, "CommonFilter", $$v)
      },
      expression: "FilterData.CommonFilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.FilterData.CommonFilter
    },
    on: {
      "click": function($event) {
        _vm.Clearfilter()
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Type Of Client ")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientTypesLabelsList,
      "id": "clientNamenew",
      "option-value": "clientTypeVal",
      "option-text": "clientTypeText",
      "placeholder": "Type Of Client"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.FilterData.ClientTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.FilterData, "ClientTypeFilter", $$v)
      },
      expression: "FilterData.ClientTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientTypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Client Type"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.FilterData.ClientType),
      callback: function($$v) {
        _vm.$set(_vm.FilterData, "ClientType", $$v)
      },
      expression: "FilterData.ClientType"
    }
  })], 1), _vm._v(" "), (
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
    _vm.$sessionsStorage.get('cust_username') == 'admin'
  ) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusTypeList,
      "option-value": "StatusTypeVal",
      "option-text": "StatusTypeTxt",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.viewClientDetail
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.clientListView)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllClientIds.length) + ")")]), _vm._v(" "), (_vm.AllClientIds.length > 0) ? _c('Send-Email', {
    attrs: {
      "AgentId": _vm.AllClientIds,
      "AllEmailId": _vm.AllEmailId,
      "type": _vm.FilterData.ClientType ? _vm.FilterData.ClientType + ' Client' : 'Client'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.clientListView,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "clientId",
      fn: function(row2) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row2.item.clientId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row2.item.clientId,
            "name": "approval",
            "value": row2.item.clientIsActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row2.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row2.item.clientIsActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row2.item.clientId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row2.item.clientIsActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "clientName",
      fn: function(row11) {
        return [_c('div', {
          staticClass: "showMoreData",
          style: (row11.item.isKYC != 'Yes' ? 'color:red' : ''),
          on: {
            "click": function($event) {
              _vm.viewClientpage(row11.item)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(row11.item.clientName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Client Type : " + _vm._s(row11.item.clientType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Created By : " + _vm._s(row11.item.CreatedBy))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Created At : " + _vm._s(row11.item.CreatedDate))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [(row11.item.isKYC != 'Yes') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Kyc Not Done")]) : _vm._e()], 1)])]
      }
    }, {
      key: "is_lead",
      fn: function(row2) {
        return [(
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
          _vm.$sessionsStorage.get('cust_username') == 'admin'
        ) ? _c('model-list-select', {
          attrs: {
            "list": _vm.clientTypeTableList,
            "id": "clientNamenew",
            "option-value": "val",
            "option-text": "type",
            "placeholder": "Client Type"
          },
          on: {
            "input": function($event) {
              _vm.updateClientType(row2.item)
            }
          },
          model: {
            value: (row2.item.is_lead),
            callback: function($$v) {
              _vm.$set(row2.item, "is_lead", $$v)
            },
            expression: "row2.item.is_lead"
          }
        }) : _vm._e(), _vm._v(" "), _c('h6', [_c('b-badge', {
          attrs: {
            "variant": row2.item.is_lead == 2 ?
              'primary' :
              row2.item.is_lead == 3 ?
              'warning' :
              row2.item.is_lead == 4 ?
              'secondary' :
              'success'
          }
        }, [_vm._v(_vm._s(row2.item.is_lead == 2 ?
          "Lead Client" :
          row2.item.is_lead == 3 ?
          "Prerequisite Client" :
          row2.item.is_lead == 4 ?
          "KYC Template Client" :
          "Direct KYC Client"))])], 1)]
      }
    }, {
      key: "phoneKYC",
      fn: function(row1) {
        return [_c('span', [_vm._v("Contact No. : " + _vm._s(row1.item.phoneKYC))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Email-Address : " + _vm._s(row1.item.email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Alternate Email-Addr : " + _vm._s(row1.item.altMail))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Corporate Address : " + _vm._s(row1.item.corporateAddress) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(row1.item.stateName) + "\n            ")])]
      }
    }, {
      key: "enq_no",
      fn: function(row4) {
        return [_c('span', [_vm._v("Enq No. : " + _vm._s(row4.item.enq_no))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Container Det. : " + _vm._s(row4.item.containerDetails))])]
      }
    }, {
      key: "clientIsActive",
      fn: function(row3) {
        return [_c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.goToDrag(row3.item)
            }
          }
        }, [_vm._v("Clients Excell Temp")]), _vm._v(" "), (
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
          _vm.$sessionsStorage.get('cust_username') == 'admin'
        ) ? _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.downloadZip(row3.item)
            }
          }
        }, [_vm._v("Download Zip")]) : _vm._e(), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.deleteClient(row3.item.clientId)
            }
          }
        }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "sales-client-upload-modal",
      "title": "Upload Sales Person - Client Mapping",
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": function($event) {
        _vm.showUploadModal = false
      }
    },
    model: {
      value: (_vm.showUploadModal),
      callback: function($$v) {
        _vm.showUploadModal = $$v
      },
      expression: "showUploadModal"
    }
  }, [_c('SalesClientUpload', {
    on: {
      "upload-success": _vm.handleUploadSuccess
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585c6f37","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/clients/viewClient.vue
// module id = 2655
// module chunks = 0